export default "__VITE_ASSET__Cf67BGjj__"